export default {
  settings: {
    title: "Datenexport",
    // Sagt in einem Satz, was der Export ist und was er nicht ist — die CSV-Schaltflächen in den
    // Übersichten sehen für Kundinnen und Kunden ähnlich aus und liefern etwas ganz anderes.
    intro:
      "Hier fordern Sie eine vollständige Kopie aller Daten an, die Ihr Unternehmen in Lewara eingestellt hat: Projekte, [[cr.pl]], [[hwr.pl]], Stammdaten und alle hochgeladenen Dokumente. Sie erhalten ein ZIP-Archiv mit maschinenlesbaren JSON-Dateien, den gewohnten CSV-Tabellen und Ihrer Dateiablage.",
    request: "Export anfordern",
    requesting: "Wird angefordert ...",
    // Erklärt die Wartezeit, bevor sie eintritt.
    queued_hint:
      "Die Erstellung läuft im Hintergrund und kann je nach Datenmenge einige Minuten dauern. Sie können diese Seite verlassen.",
    empty: "Sie haben bisher keinen Export angefordert.",
    table: {
      requested: "Angefordert",
      status: "Status",
      size: "Größe",
      contents: "Inhalt",
      available_until: "Verfügbar bis",
      action: "Archiv",
    },
    status: {
      QUEUED: "In Warteschlange",
      RUNNING: "Wird erstellt",
      READY: "Bereit",
      FAILED: "Fehlgeschlagen",
      EXPIRED: "Abgelaufen",
    },
    // {documents} Datensätze, {files} Dateien
    contents: "{documents} Datensätze, {files} Dateien",
    download: "Herunterladen",
    // Der Datensatz bleibt bestehen, die Datei nicht — das muss die Oberfläche erklären, sonst wirkt
    // eine abgelaufene Zeile wie ein Fehler.
    expired_hint: "Das Archiv wurde nach Ablauf der Frist gelöscht. Fordern Sie bei Bedarf ein neues an.",
    already_pending: "Es wird bereits ein Export erstellt. Bitte warten Sie, bis er fertig ist.",
    load_failed: "Die Liste der Exporte konnte nicht geladen werden.",
    request_failed: "Der Export konnte nicht angefordert werden.",
    download_failed: "Das Archiv konnte nicht heruntergeladen werden.",
  },
}
